<template>
  <data-layout :active="4">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Mark Price</h4>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Start Time</th>
                  <th>Symbol</th>
                  <th>Mark Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2020/03/09 11:13:47</td>
                  <td>BTC - USDQ</td>
                  <td>$7847.33</td>
                </tr>
                <tr>
                  <td>2020/03/09 11:13:47</td>
                  <td>BTC - USDQ</td>
                  <td>$7847.33</td>
                </tr>
                <tr>
                  <td>2020/03/09 11:13:47</td>
                  <td>BTC - USDQ</td>
                  <td>$7847.33</td>
                </tr>
                <tr>
                  <td>2020/03/09 11:13:47</td>
                  <td>BTC - USDQ</td>
                  <td>$7847.33</td>
                </tr>
                <tr>
                  <td>2020/03/09 11:13:47</td>
                  <td>BTC - USDQ</td>
                  <td>$7847.33</td>
                </tr>
                <tr>
                  <td>2020/03/09 11:13:47</td>
                  <td>BTC - USDQ</td>
                  <td>$7847.33</td>
                </tr>
                <tr>
                  <td>2020/03/09 11:13:47</td>
                  <td>BTC - USDQ</td>
                  <td>$7847.33</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </data-layout>
</template>

<script>
import DataLayout from "../../../components/Layouts/DataLayout.vue";
export default {
  components: { DataLayout },
};
</script>
